import React, { useState, useEffect } from "react";
import { Box, Text, VStack, Link, IconButton, HStack, Select, Checkbox, Spacer } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";

const DataCollarStatus = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMinutes, setSelectedMinutes] = useState(5);
  const [filterTxHash, setFilterTxHash] = useState(false);

  const apiUrl = "https://blindfoldcapital.com/api/bot_status/";

  // Fetch data from the API
  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const now = new Date();
      const oneDayAgo = now.getTime() - 24 * 60 * 60 * 1000; // 24 hours in milliseconds

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      // Filter data to include only the last 24 hours
      const filteredData = result.data.filter((entry) => {
        const entryTime = new Date(entry.timestamp).getTime();
        const now = new Date().getTime();
        const selectedTimeAgo = now - selectedMinutes * 60 * 1000;
        const txHashRegex = /(0x[a-fA-F0-9]{64})/g;
        const hasTxHash = txHashRegex.test(entry.status);
        return entryTime >= selectedTimeAgo && (!filterTxHash || hasTxHash);
      });

      setData(filteredData);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
  }, [selectedMinutes, filterTxHash]);

  // Function to format the date and time without seconds
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const formatStatusWithLinks = (status) => {
    if (!status) return "No status available";
    const txHashRegex = /(0x[a-fA-F0-9]{64})/g;
    return status.split(txHashRegex).map((part, index) =>
      txHashRegex.test(part) ? (
        <Link key={index} href={`https://arbiscan.io/tx/${part}`} color="blue.500" isExternal>
          View Transaction
        </Link>
      ) : (
        part
      )
    );
  };

  return (
    <Box
      fontSize="sm"
      fontFamily="Sentinel"
      //border="1px solid silver"
      
      h="380px"
      
      overflowY="auto"
    >

      <HStack p={2}>
        <Select maxWidth="150px" size="xs" value={selectedMinutes} onChange={(e) => setSelectedMinutes(Number(e.target.value))}>
          <option value={5}>Last 5 Minutes</option>
          <option value={10}>Last 10 Minutes</option>
          <option value={30}>Last 30 Minutes</option>
          <option value={60}>Last 60 Minutes</option>
          <option value={120}>Last 2 Hours</option>
          <option value={360}>Last 6 Hours</option>
          <option value={720}>Last 12 Hours</option>
          <option value={1440}>Last 24 Hours</option>
        </Select>
        <Checkbox size="sm" isChecked={filterTxHash} onChange={(e) => setFilterTxHash(e.target.checked)}>
          Only Tx.
        </Checkbox>
        <Spacer/>
        <IconButton
          icon={<FiRefreshCw />}
          size="xs"
                variant="outline"
                bg="white"
          colorScheme="blue"
          onClick={fetchData}
          isLoading={loading}
          aria-label="Refresh Data"
        />
      </HStack>

      <VStack align="start" spacing={1} px={2}>
        {loading ? (
          <Text>Loading...</Text>
        ) : error ? (
          <Text color="red.500">Error: {error}</Text>
        ) : (
          data
            .slice()
            .reverse()
            .map((entry, index) => (
              <Box key={index} p={1} border="2px solid dodgerblue" w="100%" bg="gray.100">
                <Text fontWeight="bold">{formatDate(entry.timestamp)}</Text>
                <Text overflow="auto" maxWidth="260px">
                  {formatStatusWithLinks(entry.status)}
                </Text>
              </Box>
            ))
        )}
      </VStack>
    </Box>
  );
};

export default DataCollarStatus;
